import { DataBean } from "../DataBean";

export class Project extends DataBean {

    public async getProjectByCode(code: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.Project_getProjectByCode_String", [code]);
    }

    public async getProjectModificationReport(idEmployee: number, idProject: number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getProjectModificationReport_Number_Number", [idEmployee, idProject]);
    }

    public async getProjectCatalog(code: Number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProjectCatalog_Number", [code]);
    }

    public async getProjectRender(page: number, rows: any, props: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getProjectRender_Number_Number_java.util.Map",
            [page, rows, props]
        );
    }

}
